import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type RequestBulkOrderDeleteMutationVariables = Types.Exact<{
  input: Types.RequestBulkOrderDeleteInput;
}>;


export type RequestBulkOrderDeleteMutation = { __typename?: 'Mutation', requestBulkOrderDelete: { __typename?: 'BulkOrderDeleteJobPayload', bulkOrderDeleteJob?: { __typename?: 'BulkOrderDeleteJobDocument', jobId: string, status: Types.BulkOrderDeleteJobStatus, createdAt: Types.TDateISO, startedAt?: Types.TDateISO | null, completedAt?: Types.TDateISO | null, totalCount: number, processedCount: number, deletedCount: number, failedCount: number } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type CancelBulkOrderDeleteJobMutationVariables = Types.Exact<{
  input: Types.CancelBulkOrderDeleteJobInput;
}>;


export type CancelBulkOrderDeleteJobMutation = { __typename?: 'Mutation', cancelBulkOrderDeleteJob: { __typename?: 'BulkOrderDeleteJobPayload', bulkOrderDeleteJob?: { __typename?: 'BulkOrderDeleteJobDocument', jobId: string, status: Types.BulkOrderDeleteJobStatus, createdAt: Types.TDateISO, startedAt?: Types.TDateISO | null, completedAt?: Types.TDateISO | null, totalCount: number, processedCount: number, deletedCount: number, failedCount: number } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const RequestBulkOrderDeleteDocument = new TypedDocumentString(`
    mutation RequestBulkOrderDelete($input: RequestBulkOrderDeleteInput!) {
  requestBulkOrderDelete(input: $input) {
    bulkOrderDeleteJob {
      ...BulkOrderDeleteJobSummary
    }
    errors {
      code
      message
    }
  }
}
    fragment BulkOrderDeleteJobSummary on BulkOrderDeleteJobDocument {
  jobId
  status
  createdAt
  startedAt
  completedAt
  totalCount
  processedCount
  deletedCount
  failedCount
}`);
export const CancelBulkOrderDeleteJobDocument = new TypedDocumentString(`
    mutation CancelBulkOrderDeleteJob($input: CancelBulkOrderDeleteJobInput!) {
  cancelBulkOrderDeleteJob(input: $input) {
    bulkOrderDeleteJob {
      ...BulkOrderDeleteJobSummary
    }
    errors {
      code
      message
    }
  }
}
    fragment BulkOrderDeleteJobSummary on BulkOrderDeleteJobDocument {
  jobId
  status
  createdAt
  startedAt
  completedAt
  totalCount
  processedCount
  deletedCount
  failedCount
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    RequestBulkOrderDelete: build.mutation<RequestBulkOrderDeleteMutation, RequestBulkOrderDeleteMutationVariables>({
      query: (variables) => ({ document: RequestBulkOrderDeleteDocument, variables })
    }),
    CancelBulkOrderDeleteJob: build.mutation<CancelBulkOrderDeleteJobMutation, CancelBulkOrderDeleteJobMutationVariables>({
      query: (variables) => ({ document: CancelBulkOrderDeleteJobDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useRequestBulkOrderDeleteMutation, useCancelBulkOrderDeleteJobMutation } = injectedRtkApi;
